module.exports = __webpack_public_path__ + "static/crisis1-d49b90ed535607cd743d518dedc13b63.jpg";